import debounce from "lodash.debounce";
import { useEffect, useState } from "react";

const useWindowSize = (delay = 300) => {
  const [size, setSize] = useState([0, 0]);
  useEffect(() => {
    const updateSize = () => {
      setSize([window.innerWidth, window.innerHeight]);
    };
    const debouncedHandleResize = debounce(updateSize, delay);
    window.addEventListener("resize", debouncedHandleResize);
    updateSize();
    return () => window.removeEventListener("resize", debouncedHandleResize);
  }, [delay]);
  return size;
};

export default useWindowSize;
